export default __webpack_public_path__ + "static/media/banner2.773bd194.webp";